import { z } from "zod";

export const MoodSchema = z.number().int().min(0).max(4);
export type Mood = z.infer<typeof MoodSchema>;

export const ScaleSchema = z.number().int().min(0).max(10);
export type Scale = z.infer<typeof ScaleSchema>;

export const CheckInInputSchema = z.object({
  mood: MoodSchema,
  energy: ScaleSchema.optional(),
  stress: ScaleSchema.optional(),
  note: z.string().max(500).optional(),
  clientCreatedAt: z.string().datetime(),
  idempotencyKey: z.string().uuid(),
});

export type CheckInInput = z.infer<typeof CheckInInputSchema>;

export const CheckInSchema = CheckInInputSchema.extend({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  createdAt: z.string().datetime(),
});

export type CheckIn = z.infer<typeof CheckInSchema>;
